<!-- =========================================================================================
    File Name: TechnicItem.vue
    Description: Single technic item component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div @click="displayPrompt" class="px-4 list-item-component" :class="colorizeLabel(serviceItem.serviceStatusId)">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-3/4 flex sm:items-center sm:flex-row flex-col">
        <div class="flex items-center" :class="setClasses('mobSatir', 'tekSatir')">
          <!-- <vs-checkbox v-model="isDone" class="w-8 m-0 vs-checkbox-small" @click.stop></vs-checkbox> -->
          <h6 class="technic-title" :class="{ 'line-through': isDone }">
            <span
              v-bind:title="
                'Oluşturulma Tarihi: ' +
                  $moment(serviceItem.createdDate)
                    .locale('tr')
                    .format('DD.MMMM.YYYY')
              "
              >{{
                $moment(serviceItem.createdDate)
                  .locale("tr")
                  .format("DD.MMMM.YYYY")
              }}</span
            >
            <span v-bind:style="colorizeIfMatched('serviceId') ? matchedStyle : unmatchedStyle" v-bind:title="serviceItem.serviceId">#Id: {{ serviceItem.serviceId }}</span>
            <span v-if="serviceItem.odooId" v-bind:style="colorizeIfMatched('odooId') ? matchedStyle : unmatchedStyle" v-bind:title="serviceItem.serviceId">{{ serviceItem.odooId }}</span>
            <span v-if="serviceItem.price" v-bind:style="colorizeIfMatched('price') ? matchedStyle : unmatchedStyle" v-bind:title="serviceItem.serviceId">{{ serviceItem.price }}</span>
            <span v-bind:title="serviceItem.customerName" v-bind:style="colorizeIfMatched('customerName') ? matchedStyle : unmatchedStyle">
              {{ trimString(serviceItem.customerName, 30) }}
            </span>
            <span v-bind:title="'Ürünler: ' + printProducts(serviceItem.products)" v-bind:style="colorizeIfMatched('products') ? matchedStyle : unmatchedStyle">
              Ürünler:
              {{ printProducts(serviceItem.products).substr(0, 30) }}
            </span>
            <span v-bind:style="colorizeIfMatched('assignedUser') ? matchedStyle : unmatchedStyle" v-bind:title="'Atanan personel: ' + serviceItem.assignedUser"
              >Personel: {{ serviceItem.assignedUser ? serviceItem.assignedUser.substr(0, 30) : "Personel Bulunamadı" }}</span
            >
          </h6>
        </div>
      </div>
      <div class="vx-col w-full sm:w-1/4 ml-auto flex sm:justify-end sm:flex hidden m-auto">
        <div class="sm:ml-2 sm:my-0 my-2 flex items-center sm:flex hidden m-auto">
          <vs-chip style="font-size: 7px; white-space: nowrap">
            <feather-icon :title="serviceItem.serviceStatus" class="satirIcon" :icon="serviceStatusIcon(serviceItem.serviceStatusId)" :class="colorizeLabel(serviceItem.serviceStatusId)"></feather-icon>
          </vs-chip>
          <vs-chip style="font-size: 7px; white-space: nowrap">
            <i :title="serviceItem.serviceType" style="font-size: 16px" class="satirIcon" :class="'vs-icon notranslate icon-scale material-icons ' + colorizeorderTypeList(serviceItem.serviceTypeId, false)">{{
              colorizeorderTypeList(serviceItem.serviceTypeId, true)
            }}</i>
          </vs-chip>
        </div>
        <feather-icon title="Fatura'ya yolla / Görüntüle" icon="FileTextIcon" class="cursor-pointer stroke-current mr-6" @click.stop="openInvoicePopup"></feather-icon>
        <div class="mr-12" v-if="!serviceItem.displayTransferProgress">
          &nbsp;
        </div>
        <feather-icon v-if="serviceItem.displayTransferProgress" title="Transfer" icon="SendIcon" class="cursor-pointer info stroke-current mr-6" @click.stop="openTransferPopup"></feather-icon>
        <feather-icon title="Mesaj Ekle" icon="MessageSquareIcon" class="cursor-pointer text-success stroke-current mr-6" @click.stop="openAddMessagePopup"></feather-icon>
        <div class="mr-6" v-if="!displayQuickActions()">&nbsp;</div>
        <feather-icon v-if="displayQuickActions()" title="Hızlı İşlem Menüsü" icon="ExternalLinkIcon" class="cursor-pointer text-danger stroke-current" @click.stop="openAssignPopup"></feather-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
export default {
  //TODO: v-model child component örneği
  props: {
    serviceItem: {
      type: Object,
    },
    value: "",
  },
  data() {
    return {
      matchedStyle: {
        backgroundColor: "#ffcccc!important",
      },
      unmatchedStyle: {
        backgroundColor: "!important",
      },
      isDone: false,
      serviceStatus: [],
      orderTypeList: [],
      serviceStatusSeleciton: "",
    };
  },
  methods: {
    displayQuickActions() {
      return [0, 1, 2, 3, 4, 5, 6, 9, 10, 11].includes(this.serviceItem.transferStatus);
    },
    displayPrompt() {
      this.$emit("showDisplayPrompt", this.serviceItem.serviceId);
    },
    colorizeIfMatched(val) {
      let firstCheck = typeof this.value != "undefined" && typeof this.value.field != "undefined";
      if (!firstCheck || this.value.value.length < 4) {
        return false;
      }
      if (typeof this.serviceItem[val] != "undefined" && repository.convertToEnglish(JSON.stringify(this.serviceItem[val]).toLowerCase()).indexOf(this.value.value) >= 0) {
        return true;
      }
      if (firstCheck) {
        if (val == "customerName" && this.value.field == "customerPhone" && JSON.stringify(this.serviceItem["customerPhone"]).indexOf(this.value.value) >= 0) {
          return true;
        }
        if (val == "customerName" && this.value.field == "deliveredBY" && repository.convertToEnglish(JSON.stringify(this.serviceItem["deliveredBY"]).toLowerCase()).indexOf(this.value.value) >= 0) {
          return true;
        }
      }
      return false;
    },
    openAssignPopup() {
      this.$emit("openAssignPopup", this.serviceItem.serviceId);
    },
    openAddMessagePopup() {
      this.$emit("openAddMessagePopup", this.serviceItem.serviceId);
    },
    openTransferPopup() {
      this.$emit("openTransferPopup", this.serviceItem.serviceId);
    },
    openInvoicePopup() {
      this.$emit("openInvoicePopup", this.serviceItem.serviceId);
    },
    trimString(val, len) {
      if (!val) return "";
      val = val.trim();
      if (val != null && val.length > len) val = val.substr(0, len);
      return val;
    },
    convertToDateTime(val) {
      if (val == null || !val) return "";
      let x = new Date(val);
      if (x == null || typeof x != "object" || !x) return "";
      return x.toLocaleDateString() + " " + x.toLocaleTimeString();
    },
    colorizeLabel(id) {
      if (!this.serviceStatus) return "";
      let y = this.serviceStatus[id];
      if (!y || !y.classList) return "";
      return y.classList;
    },
    serviceStatusIcon(id) {
      let y = this.serviceStatus[id];
      if (!y || !y.other || !y.other.icon) return "";
      return y.other.icon;
    },
    colorizeorderTypeList(id, color) {
      if (!this.orderTypeList) return "";
      let y = this.orderTypeList[id];
      if (!y || !y.classList) return "";
      return color ? y.style.split("|")[0] : y.classList;
    },
    setClasses(a, b) {
      return navigator.isMobile ? a : b;
    },
    printProducts(r) {
      return r
        .map((r) => r.productName)
        .map((r) => r[0].name)
        .join();
    },
  },
  created() {
    if (localStorage["technicstatusList"]) {
      this.serviceStatus = repository.convertToJSON(localStorage["technicstatusList"], "other");
    }
    if (localStorage["technictypeList"]) {
      this.orderTypeList = repository.convertToJSON(localStorage["technictypeList"], "other");
    }
  },
};
</script>

<style lang="scss" scoped>
.tekSatir {
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;
  font-size: 8px;
}

.mobSatir {
  padding: 4px;
  white-space: normal;
  overflow-x: visible;
}
</style>
